import { client, gql } from './Client';

const fieldInspectorsQuery = gql`
  query allInspectorsInfo {
    allInspectorsInfo {
      pkInspector
      fkUser
      fkServiceProvider
      isLeadInspector
      isActive
      companyName
      title
      firstName
      lastName
      phone
      emailAddress
      primaryAddress
      abbrv
      comment
      dateModified
      modifiedBy
    }
  }
`;

const fieldInspectors = () => client.query({ query: fieldInspectorsQuery });

export { fieldInspectors };
